import React from 'react';
import { MobileCloseIconContainer } from './styles';

const MobileCloseIcon = (props) => {
  return (
    <MobileCloseIconContainer {...props}>
      <div>
        <img src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' role='presentation'%3E%3Cpath d='M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z' fill='black'/%3E%3C/svg%3E" />
      </div>
    </MobileCloseIconContainer>
  );
};

export default MobileCloseIcon;
